import '@fortawesome/fontawesome-pro/css/all.min.css';
import '@fortawesome/fontawesome-pro/css/sharp-solid.css';
import 'styles/main/front-royal.scss';
import { bootstrapFrontRoyalApp } from 'FrontRoyalReact';
import { hydrateMobileAuthToken } from 'MobileAuthToken';
import { logTinyEvent } from 'TinyEventLogger';

const logError = (event: string, error: unknown) => {
    logTinyEvent(event, { message: error instanceof Error ? error.message : String(error) });
};

async function init() {
    // On mobile, hydrate the auth token cache from native Preferences storage before React mounts,
    // so any RTK Query / Angular $http / WebSocket code reads a populated token. The .catch
    // swallows any Preferences failure so React still mounts and the user can re-login.
    if (window.CORDOVA) {
        await hydrateMobileAuthToken().catch(error => logError('hydrate_mobile_auth_token_failed', error));
    }

    bootstrapFrontRoyalApp();
}

init().catch(error => logError('init_failed', error));
